import { FormControlLabel, Switch } from '@mui/material';
import type { ReactNode } from 'react';

const rowSx = { justifyContent: 'space-between', ml: 0, mr: 0, width: '100%' } as const;
// Left only — a right margin would inset the switch from the edge PreferenceSelect's trigger sits flush against.
const switchSx = { ml: 1 } as const;
const labelSlotProps = { typography: { variant: 'body2' as const } };

type PreferenceSwitchProps = {
  label: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
};

/** Preferences-drawer switch row: label on the left, switch aligned to the right edge. */
export function PreferenceSwitch({ label, checked, onChange, disabled }: PreferenceSwitchProps) {
  return (
    <FormControlLabel
      label={label}
      labelPlacement="start"
      slotProps={labelSlotProps}
      sx={rowSx}
      control={<Switch sx={switchSx} checked={checked} onChange={(_, value) => onChange(value)} disabled={disabled} />}
    />
  );
}
